export default __webpack_public_path__ + "static/media/compiegne19.98b2621b.jpg";